var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgProfileMarket = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2227 24.5547H6.00049C5.4482 24.5547 5.00049 25.0024 5.00049 25.5547V25.9991C5.00049 26.5514 5.4482 26.9991 6.00049 26.9991H16.2227C16.775 26.9991 17.2227 26.5514 17.2227 25.9991V25.5547C17.2227 25.0024 16.775 24.5547 16.2227 24.5547Z",
    fill: "#4987FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7782 22.1094H8.44482C7.89254 22.1094 7.44482 22.5571 7.44482 23.1094V24.776C7.44482 25.3283 7.89254 25.776 8.44483 25.776H13.7782C14.3304 25.776 14.7782 25.3283 14.7782 24.776V23.1094C14.7782 22.5571 14.3304 22.1094 13.7782 22.1094Z",
    fill: "#4987FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.667 22.5556L18.0004 13.8889L20.3337 11.5556C20.7781 12 21.4448 12 21.8893 11.5556C22.3338 11.1111 22.3337 10.4445 21.8893 9.99999L17.2226 5.33332C16.7782 4.88889 16.1115 4.88889 15.667 5.33332C15.2226 5.77775 15.2226 6.44441 15.667 6.88889L9.44481 13.2222C9.00038 12.7778 8.22257 12.7778 7.77814 13.2222C7.33372 13.6667 7.33372 14.3333 7.77814 14.7778L12.5559 19.4445C13.0003 19.8889 13.667 19.8889 14.1115 19.4445C14.556 19 14.5559 18.3334 14.1115 17.8889L16.4448 15.5556L25.1115 24.2222C25.5559 24.6667 26.2226 24.6667 26.667 24.2222C27.1115 23.7778 27.1115 23 26.667 22.5556Z",
    fill: "#4987FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgProfileMarket);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/profile-market.279b2356ae104a4a76ec137227029dff.svg";